import { IPartTimeNSUFRAdvisoryProperties, MissionFeatureCollection } from '@autopylot-internal/tiles-client';
import { NoWrap } from '../../components/typography/NoWrap.tsx';
import { formatLocalDateAndTime } from '../../support/helpers/format.ts';
import { SecondaryWarningAdvisory } from '../SecondaryAdvisory.tsx';

export const PartTimeNSUFRAdvisory = (props: IPartTimeNSUFRAdvisoryProperties & { mission: MissionFeatureCollection } ) => {
    return (
        <SecondaryWarningAdvisory header="Part Time National Security Warning" advisoryType={props.advisoryType} GLOBAL_ID={props.GLOBAL_ID}>
            <>
                Flights are strictly prohibited in National Security Restricted Flights Zones. Your mission overlaps <strong>{props.Base || props.Facility}</strong>. This restriction applies from <strong><NoWrap>{formatLocalDateAndTime({ time: props.ACTIVETIME, location: props.mission.getMissionCenter() })}</NoWrap> to <NoWrap>{formatLocalDateAndTime({ time: props.ENDTIME, location: props.mission.getMissionCenter() })}</NoWrap></strong>. The POC for this airspace is <strong>{props.POC}</strong>.
            </>
        </SecondaryWarningAdvisory>
    );
};
